export default {
  education: {
    webinar: {
      title: "Жазбаға қол жеткізу үшін іс-шараға тіркеліңіз",
      text: "Ағымдағы тіркелгі деректерімен автоматты түрде кіруге немесе келесі қадамда деректерді қолмен енгізуге болады.",
      label: "Тіркелу арқылы сіз қабылдайсыз",
      link: "MTS Link сервистік серіктесіне аудару шарттары",
      close: "Деректерді қолмен енгізіңіз",
      submit: "Тіркелу",
    },
    metaTitle: "Білім",
    noContentLang: "Бұл тілде әлі жарияланған материалдар жоқ.",
    titles: {
      material: "Дәрігерлерге арналған оқу",
      course: "Дәрігерлерге арналған оқу курстары",
      simulator: "Дәрігерлерге арналған тренажерлер",
      webinar: "Дәрігерлерге арналған вебинарлар",
    },
    filters: {
      selects: {
        type: {
          placeholder: "Материалдардың түрі",
        },
        lang: {
          placeholder: "Тіл",
        },
        status: {
          placeholder: "Күйі",
          values: {
            actual: "Ағымдағы",
            overpast: "Өткен",
          },
        },
        specialty: {
          placeholder: "Мамандығы",
        },
      },
      tabs: {
        material: "Барлық материалдар",
        course: "Курстар",
        simulator: "Тренажерлер",
        webinar: "Вебинарлар",
      },
    },
    content: {
      subtitles: {
        your: {
          material: "Сіздің материалдарыңыз",
          course: "Сіздің курстарыңыз",
          simulator: "Сіздің тренажерлеріңіз",
          webinar: "Сіздің вебинарларыңыз",
        },
        recomended: {
          material: "Ұсынылған материалдар",
          course: "Ұсынылған курстар",
          simulator: "Ұсынылған тренажерлер",
          webinar: "Ұсынылған вебинарлар",
        },
      },
    },
  },
  Lessons: {
    Lesson: {
      title: "Сабақ",
      Files: "Қосымшалар",
      DownloadAll: "Барлығын жүктеу",
    },
    status: {
      success: "Өтілді",
      unsuccess: "Өтпеді",
      stop: "Қол жетімсіз",
    },
  },
  Tests: {
    table: {
      tests: "Тесттер",
      description: "Сипаттама",
      points: "Ұпай",
      status: "Статус",
    },
    modal: {
      title: "Тесті аяқтағыңыз келе ме?",
    },
    questions: {
      question: "Сұрақ",
      answer: "Жауап",
      correct: "Дұрыс",
      incorrect: "Қате",
      moderated: "Тексеруде",
      navigation: "Тестті аралау",
      enterAnswer: "Жауапты енгізіңіз...",
    },
    errors: {
      required: "Міндетті сұрақ",
    },
    submit: "Тестті аяқтау",
    result: "Нәтиже",
    repeat: "Қайта өту",
  },
  afterPayCourse: {
    title: "Сіз курсты сәтті аяқтадыңыз",
    text: "Енді сіз оқу материалдарына қол жеткізе аласыз",
    buttonText: "Курсқа өту",
  },
  coursePage: {
    courseType: {
      course: "Курс",
      simulator: "Тренажер",
      webinar: "Вебинар",
    },
    groupNumber: "{n} - ші ағын",
    manager: "Менеджер",
    curator: "Куратор",
    free: "Тегін",
  },
  coursesPage: {
    materials: "Материалдар",
    schools: "Авторлық мектептер",
    universities: "Жоғары оқу орындары",
    showPast: "Өткенді көрсету",
    emptyList: "Мұндай материалдар жоқ",
    show: "Көрсету",
    result1: "нәтижесі",
    result2: "нәтижесі",
    result5: "нәтижесі",
    filters: "Сүзгілер",
    clear: "Тазалау",
  },
};
